<template>
  <EIconButton
    v-bind="$attrs"
    :icon="icon"
    as="a"
    icon-size="s"
    variant="bare"
    rounded
    v-on="$listeners"
  />
</template>

<script>
import EIconButton from '~~/common/vue/components/icon-button';

const sides = ['left', 'right'];

export default {
  name: 'EPaginationControl',
  components: {
    EIconButton,
  },
  props: {
    side: {
      type: String,
      validator: (value) => sides.includes(value),
      default: sides[0],
    },
  },
  computed: {
    icon() {
      return `chevron-${this.side}`;
    },
  },
};
</script>
